export enum OrderFilterStateEnum {
  SELECTED_ORDER = 'SELECTED_ORDER',
  ALL_ORDERS = 'ALL_ORDERS',
}
